export default "__VITE_ASSET__abc64cc8__"